export function getDateTimeWithUnderscores(): string {
	const now = new Date();
	const year = now.getFullYear();
	const month = `${now.getMonth() + 1}`.padStart(2, '0'); // Months are 0-based
	const day = `${now.getDate()}`.padStart(2, '0');
	const hours = `${now.getHours()}`.padStart(2, '0');
	const minutes = `${now.getMinutes()}`.padStart(2, '0');
	const seconds = `${now.getSeconds()}`.padStart(2, '0');

	// Format: `YYYY_MM_DD_hh_mm_ss`.
	return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
}
